exports.install = function (Vue, options) {
	//获取设备异常数据列表
	Vue.prototype.getabnormal = function(value)
	{
		this.axiosget("/api/abnormal/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('abnormal',response.data.data.list);
			}
		})
	};
}